import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Button, WhiteButton } from 'components';
import { IModalAction } from 'models/modal';
import renderIcon from 'helpers/renderIcon';
require('./style.css');

interface IProps {
	/* functions props */
	t?: (key: string) => string;
	nextPage?: () => void;
	closeModal?: () => IModalAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class GetStarted extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.closeModal = this.closeModal.bind(this);
	}

	private closeModal(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.closeModal();
	}

	public render() {
		const { t } = this.props;

		function createMarkup() {
			return { __html: t('OnboardingQuiz_StepGetStarted_Title') };
		}

		return (
			<div>
				<div className="getStarted">
					<div className="imageGetStarted">{renderIcon('symbol2')}</div>
					<h2 dangerouslySetInnerHTML={createMarkup()} />
					<p>{t('OnboardingQuiz_StepGetStarted_Desc')}</p>
					<div className="buttons">
						<div className="doItLater">
							<WhiteButton type="button" onClick={this.closeModal}>
								{t('OnboardingQuiz_StepGetStarted_Button_Later')}
							</WhiteButton>
						</div>
						<div>
							<Button type="button" onClick={this.props.nextPage}>
								{t('OnboardingQuiz_StepGetStarted_Button_GetStarted')}
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { GetStarted };
